import type { ExistingDiscountedCashFlowResult as ExistingDiscountedCashFlowResultSchema } from '@einwert/valuation-api-client'
import { useGetValuation } from 'ClientPortal/src/api/Queries/valuations'
import { throwOnForbiddenApiError } from 'ClientPortal/src/api/react-query-config'
import { useTypedParams } from 'ClientPortal/src/router/useTypedParams'

import { type DCFTableCopy, mapDCFResultsSchemaToTableDCF } from 'ComponentLibrary'

export function useValuationDCFPage(dcfTableCopy: DCFTableCopy) {
    const { valuationId } = useTypedParams(['valuationId'])
    const { valuation, isValuationPending } = useGetValuation({ valuationId, throwOnError: throwOnForbiddenApiError })

    const dcfData = valuation?.dcf ? getYearlyDCF(valuation.dcf, dcfTableCopy) : undefined

    return {
        dcfData,
        isDcfPending: isValuationPending,
    }
}

const getYearlyDCF = (dcf: ExistingDiscountedCashFlowResultSchema, dcfTableCopy: DCFTableCopy) => {
    return mapDCFResultsSchemaToTableDCF(
        {
            ...dcf,
            periods: dcf.periods.yearly,
            exit_period: dcf.exit_period.yearly,
        },
        dcfTableCopy
    )
}
